<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        On the TLC shown below, which compound has the lowest affinity for the stationary phase?
        What conclusion can we make regarding the polarity of the molecule?
      </p>

      <p class="pl-12 mb-6">
        <v-img style="max-width: 105px" :src="imageName" />
      </p>

      <v-radio-group v-model="inputs.affinityAndPolarity" :disabled="!allowEditing" class="mb-n6">
        <v-radio
          v-for="option in options"
          :key="'pt-1-' + option.value"
          class="my-1"
          :value="option.value"
        >
          <template #label>
            <stemble-latex :content="option.text" />
          </template>
        </v-radio>
      </v-radio-group>
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import ChemicalLatex from '../displayers/ChemicalLatex';
import StembleLatex from '@/tasks/components/StembleLatex';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'uOttawa1321Prelab1Q1',
  components: {
    CalculationInput,
    NumberValue,
    ChemicalLatex,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        affinityAndPolarity: null,
      },
      options: [
        {text: 'Compound A - it is the least polar compound', value: 'AleastPolar'},
        {text: 'Compound A - it is the most polar compound', value: 'AmostPolar'},
        {text: 'Compound B - it is the least polar compound', value: 'BleastPolar'},
        {text: 'Compound B - it is the most polar compound', value: 'BmostPolar'},
        {text: 'Compound C - it is the least polar compound', value: 'CleastPolar'},
        {text: 'Compound C - it is the most polar compound', value: 'CmostPolar'},
      ],
    };
  },
  computed: {
    imageNumber() {
      return this.taskState.getValueBySymbol('imageNumber').content;
    },
    imageName() {
      return prefixPublicAsset('/img/assignments/Q1-TLC-V' + this.imageNumber.value + '.png');
    },
  },
};
</script>
